export default __webpack_public_path__ + "static/media/faz_1.a707797f.png";